import { render, staticRenderFns } from "./TableFieldGroupsRestoreContainer.vue?vue&type=template&id=00034ed8&scoped=true&"
import script from "./TableFieldGroupsRestoreContainer.vue?vue&type=script&lang=js&"
export * from "./TableFieldGroupsRestoreContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00034ed8",
  null
  
)

export default component.exports